import axios from 'axios'

// 获取轮播图
export const getBannerList = () => {
    return new Promise((resolve, reject) => {
        axios.get('/gswz-web/info/list/1.0?channelid=0001000200070001').then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}


// 信息披露列表
export const getInfoList = (params) => {
    return new Promise((resolve, reject) => {
        axios.get('/gswz-web/info/list/1.0?channelid=00010001000300120002', { params }).then((res) => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        } )
    })
}

// 信息披露详情
export const getInfoDetail = (params) => {
    return new Promise((resolve, reject) => {
        axios.get( '/gswz-web/info/list/1.0', { params }).then((res) => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        } )
    })
}

// 募集账户查询
export const getRaiseAccount = (params) => {
    return new Promise((resolve, reject) => {
        axios.get('/xgj/v2/website/raiseAccount', { params }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

// 获取图片验证码
export const getCaptcha = () => {
    return new Promise((resolve, reject) => {
        axios.get('/xgj/v2/website/raiseAccount/captcha').then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

// 业绩看板登录
export const achieveLogin = (params) => {
    return new Promise((resolve, reject) => {
        axios.post('/xgj/v2/website/achievementShow/login', params).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

// 业绩看板查询
export const getAchieveAboard = (params) => {
    return new Promise((resolve, reject) => {
        axios.get('/xgj/v2/website/achievementShow/data', { params }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

// 业务动态信息
export const getServiceNews = (params) => {
    return new Promise((resolve, reject) => {
        axios.get('/gswz-web/info/list/1.0?channelid=00010001000300120001', { params }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}




